type BrandLogoProps = {
  appName: string;
  tone?: "light" | "dark";
  compact?: boolean;
  subtitle?: boolean;
};

export function BrandLogo({
  appName,
  tone = "dark",
  compact = false,
  subtitle = false,
}: BrandLogoProps) {
  return (
    <span
      className={`brand-logo brand-logo--${tone}${compact ? " brand-logo--compact" : ""}`}
    >
      <img
        className="brand-logo__icon"
        src="/brand/logo-icon.svg"
        alt=""
        width="48"
        height="48"
      />
      <span className="brand-logo__copy">
        <strong title={appName}>{compact ? "Yapısal İzin" : appName}</strong>
        {subtitle ? <small>Ekip izin ve vardiya takibi</small> : null}
      </span>
    </span>
  );
}
